import { FieldProps } from 'formik'
import { FormikDropdown } from 'formik-office-ui-fabric-react'
import { FieldStack, FieldStackItem, FormStack } from 'forms/FormStack'
import { IDropdownOption } from 'office-ui-fabric-react'
import * as React from 'react'
import { useTranslation } from 'react-i18next'

export const ProvingDetailsSetStatusForm: React.FC = () => {
  const { t } = useTranslation()

  const options: IDropdownOption[] = [
    {
      key: 1,
      text: t('enum.status.1'),
    },
    {
      key: 2,
      text: t('enum.status.2'),
    },
    {
      key: 3,
      text: t('enum.status.3'),
    },
    {
      key: 4,
      text: t('enum.status.4'),
    },
    {
      key: 5,
      text: t('enum.status.5'),
    },
    {
      key: 6,
      text: t('enum.status.6'),
    },
    {
      key: 7,
      text: t('enum.status.7'),
    },
    {
      key: 8,
      text: t('enum.status.8'),
    },
    {
      key: 9,
      text: t('enum.status.9'),
    },
    {
      key: 10,
      text: t('enum.status.10'),
    },
  ]

  return (
    <FormStack>
      <FieldStack>
        <FieldStackItem
          name="status"
          render={(fieldProps: FieldProps<any>) => (
            <FormikDropdown
              label={t('field.proving.setStatus')}
              {...fieldProps}
              options={options}
            />
          )}
        />
      </FieldStack>
    </FormStack>
  )
}
